import { render, staticRenderFns } from "./shuifeizhangdan.vue?vue&type=template&id=d2612616&scoped=true&"
import script from "./shuifeizhangdan.vue?vue&type=script&lang=js&"
export * from "./shuifeizhangdan.vue?vue&type=script&lang=js&"
import style0 from "./shuifeizhangdan.vue?vue&type=style&index=0&id=d2612616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2612616",
  null
  
)

export default component.exports